import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss?v=2.0.0";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import store from "./store";
import LoginPage from "./views/Settings/User/LoginPage";
import RootBase from "./RootBase";
import { getCompanySettings } from "./Redux/settingsReduce";

// Wrapper component to fetch settings
const SettingsFetcher = ({ children }) => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.settings);
  const token = localStorage.getItem("x-access-token");

  useEffect(() => {
    if (token && !settings) {
      dispatch(getCompanySettings()); // Updated action name
    }
  }, [dispatch, token, settings]);

  return children;
};

const App = () => {
  const token = localStorage.getItem("x-access-token");

  return (
    <Provider store={store}>
      <BrowserRouter>
        <SettingsFetcher>
          {!token ? (
            <Switch>
              <Route path="/login" render={() => <LoginPage />} key={"1"} />
              <Redirect from="/" to="/login" />
            </Switch>
          ) : (
            <RootBase />
          )}
        </SettingsFetcher>
      </BrowserRouter>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
